function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import gettext from 'js-utils/gettext';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '../../iconButton/IconButton';
import { DIRECTION_LEFT, DIRECTION_RIGHT, BOTTOM_NAVIGATION_TYPE, TYPE_NUMBER } from '../constants';
import ArrowLeftChunkySvg from '../../iconography/icons/ArrowLeftChunky';
import ArrowRightChunkySvg from '../../iconography/icons/ArrowRightChunky';
import ChevronLeftChunkySvg from '../../iconography/icons/ChevronLeftChunky';
import ChevronRightChunkySvg from '../../iconography/icons/ChevronRightChunky';

var SideNavigation =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SideNavigation, _PureComponent);

  function SideNavigation() {
    _classCallCheck(this, SideNavigation);

    return _possibleConstructorReturn(this, _getPrototypeOf(SideNavigation).apply(this, arguments));
  }

  _createClass(SideNavigation, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          onClick = _this$props.onClick,
          fullWidth = _this$props.fullWidth,
          shouldShow = _this$props.shouldShow,
          bottomNavigationType = _this$props.bottomNavigationType,
          isDisabled = _this$props.isDisabled,
          usesNewStyle = _this$props.usesNewStyle;

      if (!shouldShow && !fullWidth) {
        return null;
      }

      var className = classNames('eds-carousel__side-navigation', _defineProperty({
        'eds-carousel__side-navigation--full-width-hidden': !shouldShow && fullWidth
      }, "eds-carousel__side-navigation--full-width-".concat(type), fullWidth && bottomNavigationType !== TYPE_NUMBER));
      var title = gettext('%(direction)s navigation', {
        direction: type
      });
      var iconType = type === DIRECTION_LEFT ? React.createElement(ChevronLeftChunkySvg, null) : React.createElement(ChevronRightChunkySvg, null);

      if (usesNewStyle) {
        iconType = type === DIRECTION_LEFT ? React.createElement(ArrowLeftChunkySvg, null) : React.createElement(ArrowRightChunkySvg, null);
      }

      return React.createElement("div", {
        className: className
      }, React.createElement(IconButton, {
        iconType: iconType,
        isActive: fullWidth,
        title: title,
        onClick: onClick,
        disabled: isDisabled
      }));
    }
  }]);

  return SideNavigation;
}(PureComponent);

_defineProperty(SideNavigation, "propTypes", {
  bottomNavigationType: PropTypes.oneOf(BOTTOM_NAVIGATION_TYPE),
  type: PropTypes.oneOf([DIRECTION_LEFT, DIRECTION_RIGHT]).isRequired,
  onClick: PropTypes.func.isRequired,
  shouldShow: PropTypes.bool,
  fullWidth: PropTypes.bool,
  isDisabled: PropTypes.bool,
  usesNewStyle: PropTypes.bool
});

export { SideNavigation as default };